import { Injectable } from '@angular/core';
import { ReporttemplateService } from './reporttemplate.service';
import * as moment from 'moment';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface ConditionalOPeratorTypeWhere {
  name: string,
  value: string
}

@Injectable({
  providedIn: 'root'
})
export class ReviewActivityReportFiltersService {

  getdata: any = [];
  isExternalFilter=false;
  selectedFilter=[];
  selectedFiltersList:any=[];
  uniqueData = []
  selectedRowData;
  selectedMultipleRowData=[];
  selectedExternalFilterS3Path;
  selectedFilterManageId;
  multiSelectVaules = [];
  datasetColummnData=[];
   oldFiltersList:any;

   conditionalOperatorDataWhere: ConditionalOPeratorTypeWhere[] = [
       { name: "Matches", value: "=" },
       { name: "Does Not Matches", value: "<>" },
       { name: "Matches At Least One", value: "IN" },
       { name: "Matches At Least One (Exclude)", value: "NOT IN" },
       { name: "Starts With", value: "Starts with" },
       { name: "Ends With", value: "Ends with" },
       { name: "Contains", value: "contains" },
        { name: "Contains (Exclude)", value: "Contains (Exclude)" },
       { name: "Greater Than Or Equals", value: ">=" },
       { name: "Is Greater Than", value: ">" },
       { name: "Less Than Or Equals", value: "<=" },
       { name: "Is Less Than", value: "<" },
       { name: "Between", value: "BETWEEN" },
       { name: "Space Separated", value: "Space Separated" },
       { name: "Space Separated (Exclude)", value: "Space Separated (Exclude)" },
       // { name: "MAX", value: "MAX" },
       // { name: "MIN", value: "MIN" },
       // { name: "Calculated Field", value: "CalculatedField" },
       // { name: "Calculated Field With Filter", value: "CalculatedFieldWithFilter" },
       // { name: "Calculated Field For Reports", value: "CalculatedFieldForReports" },
       // { name: "Count", value: "count"}
     ];
  constructor(private reportService: ReporttemplateService,private reportLinkService:ReportlinksserviceService,private snackbar: MatSnackBar) { }

  async getFiltersList(selectedFiltersArray,dataSetId,templateid,reportName,extraFilters){ 
    console.log("selectedFiltersArray on open:", selectedFiltersArray);
    
    this.getdata = await this.reportService.retrieveFiltermanagebyDataSetid(dataSetId);
    console.log(this.getdata)
     this.getdata = (this.getdata || []).filter(item => {

    const status = (item.status || '').toString().toLowerCase();
    const isDeletedFlag = item.isDeleted === true || item.deleted === true || item.isActive === false;
    return status !== 'no' && !isDeletedFlag;
  });
    if(selectedFiltersArray){
      this.isExternalFilter=false
      if(selectedFiltersArray.length > 0){
        this.getdata= this.getdata.filter(item =>selectedFiltersArray.includes(item.filtermanageId));
        for(let i=0;i<this.getdata.length;i++){
          this.getdata[i]["isDisable"]=false
           /*Modified by Renuka
            * Fixed first filter duplication when editing records with multiple filters by pushing each individual filter ID instead of repeatedly pushing only the first filter ID from the array.
            */
           this.selectedFilter.push(this.getdata[i].filtermanageId)
        }
      }else{
        for(let i=0;i<this.getdata.length;i++){
          this.getdata[i]["isDisable"]=false
        }
      }
     
    }else{
    for(let i=0;i<this.getdata.length;i++){
      this.getdata[i]["isDisable"]=false
      if(selectedFiltersArray && selectedFiltersArray.length > 0){
        this.isExternalFilter=false
        for(let j=0;j<selectedFiltersArray.length;j++){
          if(this.getdata[i].filtermanageId == selectedFiltersArray[j]){
            this.selectedFilter.push(this.getdata[i].filtermanageId)
          }
        }

      }else{
        if(this.getdata[i].defaultFilter == "Yes" && this.getdata[i].status == "Yes"){
          if(this.getdata[i].isExternalFile == "Yes"){
            this.isExternalFilter=true
          }else{
            this.isExternalFilter=false
            this.selectedFilter.push(this.getdata[i].filtermanageId)
          }
          
        }else{
          if(i == this.getdata.length-1 &&  this.selectedFilter.length == 0){
            if(this.getdata.length > 1 && this.getdata[0].status == "Yes"){
              console.log(this.getdata[i]);
              this.selectedFilter.push(this.getdata[0].filtermanageId)
            }
          
          }
        }
      }
    }
    }
    this.onSelectionChanged(this.selectedFilter,templateid,reportName,extraFilters);
    // console.log(this.selectedFilter);
    // this.getVisuals();
  }

   onSelectionChanged= async (event,templateid,reportName,extraFilters) =>{
     
      console.log(this.selectedFilter);
      
      this.selectedMultipleRowData=[];
      this.selectedFiltersList=[];
      // if(this.selectedFilter.length == 0){
      //   this.selectedExternalFilterS3Path=""
      //       this.isExternalFilter=false;
      //       this.selectedFilterManageId=""
      //       for(let k =0;k<this.getdata.length;k++){
      //         this.getdata[k].isDisable=false;
      //       }
      // }
      for(let i=0;i<this.selectedFilter.length;i++){
        console.log(this.selectedFilter[i]);
        for(let j=0;j<this.getdata.length;j++){
          if(this.getdata[j].filtermanageId == this.selectedFilter[i]){
            if(this.getdata[j].isExternalFile == "Yes"){
              this.selectedFilter=[]
              this.selectedFilter.push(this.getdata[j].filtermanageId)
              console.log(this.getdata[j]);
              this.selectedExternalFilterS3Path=this.getdata[j].s3Path
              this.isExternalFilter=true;
              this.selectedFilterManageId=this.getdata[j].filtermanageId;
              for(let k =0;k<this.getdata.length;k++){
                if(this.getdata[k].filtermanageId == this.getdata[j].filtermanageId){
                  this.getdata[k].isDisable=false;
                }else{
                  this.getdata[k].isDisable=true;
                }
              }
              this.selectedFiltersList=[]
              break;
          }else{
            this.selectedExternalFilterS3Path="";
            this.isExternalFilter=false;
            this.selectedFilterManageId="";
          this.selectedMultipleRowData.push(this.getdata[j])
          let filter = JSON.parse(this.getdata[j].filters)
          for(let k =0;k<filter.length;k++){
            filter[k]["multiSelectVaules"]=[]
            filter[k]["manageFilterId"]=this.getdata[j].filtermanageId;
            for(let l=0;l<this.datasetColummnData.length;l++){
              if(filter[k].whereKey == this.datasetColummnData[l].name){
  
                  filter[k]["type"]=this.datasetColummnData[l].type;
                  console.log(filter[k].label +"********"+filter[k].whereValue);
                if(this.datasetColummnData[l].type == "DateTime" || this.datasetColummnData[l].type == "Date"){
                  if(filter[k].whereValue != "'undefined'" && filter[k].whereValue.length > 0){
                  filter[k].whereValue = this.formatDateValue(filter[k].whereValue)
                  if(filter[k].whereCondition == "BETWEEN"){
                    filter[k].whereValue1 = this.formatDateValue(filter[k].whereValue1)
                  }
                  }
                }
              }
            }
            this.selectedFiltersList.push(filter[k])
          }
          this.selectedFiltersList.push(...extraFilters)
        }
          }
        }
      }
     this.oldFiltersList=structuredClone(this.selectedFiltersList);
      // this.userId=this.localStorageSettings.getSettings('UserId');


      // Added condition to fetch and assign filter values for multiple selected filters instead of only the first filter in the array.
    //   for(let id of this.selectedFilter){
    //     const response = await this.getUserSpecificFilters(this.userId, id);
  
    //   if (response !== false) {
    //     this.currentfilterValues = JSON.parse(response);
      
    //     this.selectedFiltersList.forEach(filter => {
    //       if (filter.manageFilterId == id) {
    //       const match = this.currentfilterValues.find(f =>
    //         f.whereKey === filter.whereKey &&
    //         f.label === filter.label 
    //       );
      
    //       if (match) {          
    //         filter.whereConditionValue = match.whereConditionValue;
  
    //         // Integer value 0 was treated as falsy in condition check, preventing correct restoration of cleared values.
    //         if (match.whereValue !== null && match.whereValue !== undefined && match.whereValue !== "'undefined'")
    //            {
    //           filter.whereValue = match.whereValue;
    //         }
    //          if (match.whereValue1 !== null && match.whereValue1 !== undefined && match.whereValue1 !== "'undefined'")
    //            {
    //           filter.whereValue1 = match.whereValue1;
    //         }
    //       }
    //     }
    //       console.log("Final filter after assigning currentfilterValues:", filter);
    //     });
    //   }
    // }
   //   this.selectedFiltersList = [...this.selectedFiltersList];
      this.selectedFiltersList = JSON.parse(JSON.stringify(this.selectedFiltersList));
  
  
      console.log(this.selectedMultipleRowData);
      console.log(JSON.stringify(this.selectedFiltersList));
      
      console.log(this.selectedFiltersList);
      console.log('Final selectedFiltersList:', this.selectedFiltersList.map(f => f.label));
  
      console.log(this.uniqueData);
      this.sendDataAndClose(templateid,reportName);
    }

     sendDataAndClose = async (templateid,reportName) => {
    const selectedIds = (this.selectedFilter || []).map(String);
    const missingSelection: string[] = [];
    const missingValue: string[] = [];
    
    const isEmpty = (v: any) =>
      v === null || v === undefined ||
      (Array.isArray(v) && v.length === 0) ||
      (typeof v === 'string' && this.removeSingleQuotes(v).trim() === '');
    
    
          for(let i=0;i<this.selectedFiltersList.length;i++){
            this.selectedFiltersList[i].originalCondition=this.getOperatorNameByValue(this.selectedFiltersList[i].whereCondition);
            this.selectedFiltersList[i].originalValue=this.selectedFiltersList[i].whereValue
    
            if(this.selectedFiltersList[i].whereConditionValue === "IN" ||this.selectedFiltersList[i].whereConditionValue === "NOT IN"){
              if (Array.isArray(this.selectedFiltersList[i].whereValue)) {
                this.selectedFiltersList[i].originalValue = this.selectedFiltersList[i].whereValue.join(', ');
              }
            }
    
    
            if(this.selectedFiltersList[i].type == "DateTime" || this.selectedFiltersList[i].type == "Date"){
              if(moment(this.selectedFiltersList[i].whereValue).format('YYYY-MM-DD') != 'Invalid date'){
                this.selectedFiltersList[i].whereValue=moment(this.selectedFiltersList[i].whereValue).format('YYYY-MM-DD');
              }
              console.log(this.selectedFiltersList[i].whereValue);
              if(this.selectedFiltersList[i].whereConditionValue == "BETWEEN"){
                if(moment(this.selectedFiltersList[i].whereValue1).format('YYYY-MM-DD') != 'Invalid date'){
                  this.selectedFiltersList[i].whereValue1=moment(this.selectedFiltersList[i].whereValue1).format('YYYY-MM-DD');
                }
                
                console.log(this.selectedFiltersList[i].whereValue1);
              }
              this.selectedFiltersList[i].originalValue =this.selectedFiltersList[i].whereValue +" and "+this.selectedFiltersList[i].whereValue1
    
    
            }
            if (
              ('excludeNull' in this.selectedFiltersList[i] && this.selectedFiltersList[i].excludeNull === true) ||
              ('showOnlyNulls' in this.selectedFiltersList[i] && this.selectedFiltersList[i].showOnlyNulls === true)
            ) {
              this.selectedFiltersList[i].originalCondition =
                this.selectedFiltersList[i].excludeNull === true ? "Exclude Null" : "Show Only Null";
              this.selectedFiltersList[i].originalValue = true;
            
            }
               
          }
          this.removeDuplicatesByWhereKey()
          console.log(this.uniqueData);
          for(let i=0;i<this.uniqueData.length;i++){
    
            if(typeof this.uniqueData[i].whereValue === 'string' && this.uniqueData[i].whereCondition != "Space Separated" && this.uniqueData[i].whereCondition != "CalculatedField" && this.uniqueData[i].whereCondition != "CalculatedFieldWithFilter" && this.uniqueData[i].whereCondition != "CalculatedFieldForReports"){
              if (this.uniqueData[i].whereValue.includes(',') && this.uniqueData[i].whereCondition !=="count") {
                this.uniqueData[i].whereValue= this.uniqueData[i].whereValue.split(',').map(item => item.trim());
                if(this.uniqueData[i].whereConditionValue == 'Contains (Exclude)'){
                    this.uniqueData[i].whereCondition="NOT IN";
                    this.uniqueData[i].whereConditionValue="NOT IN";
                }else{
                   this.uniqueData[i].whereCondition="IN";
                this.uniqueData[i].whereConditionValue="IN"
                }
              } 
              if(this.uniqueData[i].whereCondition ==="count"){
                this.uniqueData[i].whereValue=""
              }
            }
            if(this.uniqueData[i].whereCondition == "Space Separated"){
              this.uniqueData[i].whereValue= this.uniqueData[i].whereValue.trim().split(' ').map(item => item.trim());
                if(this.uniqueData[i].whereConditionValue == 'Contains (Exclude)'){
                    this.uniqueData[i].whereCondition="NOT IN";
                    this.uniqueData[i].whereConditionValue="NOT IN";
                }else{
                   this.uniqueData[i].whereCondition="IN";
                this.uniqueData[i].whereConditionValue="IN"
                }
            }
            if(this.uniqueData[i].whereCondition == "Space Separated (Exclude)"){
              this.uniqueData[i].whereValue= this.uniqueData[i].whereValue.trim().split(' ').map(item => item.trim());
                this.uniqueData[i].whereCondition="NOT IN";
                this.uniqueData[i].whereConditionValue="NOT IN"
            }
            if((this.uniqueData[i].whereCondition === "IN"||this.uniqueData[i].whereCondition === "NOT IN") && this.uniqueData[i].whereValue.length === 0){
              this.uniqueData.splice(i, 1);
              i--;  
            }
          }
          let selectedFiltersListString = JSON.stringify(this.uniqueData);
          let resultData={
            selectedFiltersListString:JSON.stringify(this.uniqueData),
          }
          //this.selectedRowData.filters=selectedFiltersListString;
          
          console.log(resultData);
          this.senddata(resultData,templateid,reportName)
        
        
    }

    removeDuplicatesByWhereKey() {
    const seen = new Set();
    this.uniqueData = this.selectedFiltersList.filter(item => {
      const isCalculatedField = item.whereCondition === "CalculatedField" || item.whereCondition === "CalculatedFieldWithFilter" || item.whereCondition === "CalculatedFieldForReports"||item.whereCondition === "count"; // Check if the condition is "CalculatedField"
    
      // If it's a CalculatedField, include it without checking for uniqueness
      if (isCalculatedField) {
          return true;
      }
  
      // Otherwise, apply the original logic for uniqueness and other checks
      const shouldInclude = (!seen.has(item.whereKey) && item.whereValue) || 
                            ((item.excludeNull || item.showOnlyNulls) && !item.whereValue);
  
      if (shouldInclude) {
          seen.add(item.whereKey); // Only add to 'seen' if it's not a CalculatedField
          return true;
      }
      return false;
  });
}


  formatDateValue(event){
    return moment.utc(event).format('YYYY-MM-DD')
  }

  removeSingleQuotes(str){
    if (str === null || str === undefined) {
      return "";
    }
    if (Array.isArray(str)) {
      return str;
    }
    if (typeof str !== "string") {
      return str;
    }
      return str.replace(/['%]/g, "");
}

getOperatorNameByValue(value) {
    const match = this.conditionalOperatorDataWhere.find(item => item.value === value);
    return match ? match.name : value;
  }

  senddata(result: any,templateid,reportName) {
    console.log(result);
    console.log("***************************");
    let where=[]
    const distinctFilterManageIds = new Set<number>();
  const selectedFilterArray=[]
     let getdata= JSON.parse(result.selectedFiltersListString)
          
          let filterMap = new Map<number, any[]>();
          
         

          // Group filters by filtermanageId
          getdata.forEach((filter: any) => {
            filter.filterType = "reportFilter"
            let filtermanageId = filter.manageFilterId;
            distinctFilterManageIds.add(filtermanageId);
            delete filter.manageFilterId
            if (!filterMap.has(filtermanageId)) {
              filterMap.set(filtermanageId, []);
            }

            switch (filter.whereConditionValue) {
              case "Ends with":
                filter.whereCondition="LIKE";
                filter.whereValue = `%${filter.whereValue}`;
                break;
                
              case "Starts with":
                filter.whereCondition="LIKE";
                filter.whereValue = `${filter.whereValue}%`;
                break;
              case "contains":
                filter.whereValue = `%${filter.whereValue}%`;
                break;
                 case "Contains (Exclude)":
                filter.whereValue = `%${filter.whereValue}%`;
                break;
                case "BETWEEN":
                  filter.whereValue1 = `'${filter.whereValue1}'`.replace(/\//g, "-");
                  
                  filter.whereValue = `${filter.whereValue}`.replace(/\//g, "-")
               
                  break;

                case "IN":
                   filter.whereValue1 = `'${filter.whereValue1}'`.replace(/\//g, "-");
                  filter.whereValue = `${filter.whereValue}`.replace(/\//g, "-");
                  filter.whereValue = `(${this.formatForInString(filter.whereValue)})`;
                  break;
                   case "NOT IN":
                  filter.whereValue = `(${this.formatForInString(filter.whereValue)})`;
                  break;
              default:
                break;
            }
            
            if(filter.type=="DateTime"&&filter.whereValue=="Invalid date"){
              // console.log(filter.whereValue=="'Invalid date'")
              filter.whereValue=''
            }
            if (filter.whereConditionValue!="IN" && filter.whereConditionValue!="NOT IN" ){
            filter.whereValue = `'${filter.whereValue}'`;
            }
            //Ignoring the calculatedfield
            if (filter.whereConditionValue.toLowerCase() !== "calculatedfield".toLowerCase() && filter.whereConditionValue.toLowerCase() !== "CalculatedFieldWithFilter".toLowerCase()){
            filterMap.get(filtermanageId)?.push(filter);
            selectedFilterArray.push(filter);
            }
          });

          if(Array.from(distinctFilterManageIds).length>0){
            let obj={
              filtermanageids:Array.from(distinctFilterManageIds).join(','),
              selectedFilter:JSON.stringify(selectedFilterArray)
            }
            where.push(obj)
           }
         
           console.log(where);
           
                  
          this.reportLinkService.adhocReport(templateid, 0,where,reportName).subscribe(); 

                   this.snackbar.open("Report Initiated", "OK", {
                    duration: 5000,
                  });
  }

   formatForInString(input: string): string {
  return input
    .split(',')
    .map(item => `'${item.trim()}'`)
    .join(', ');
}
}
